import { IRewardRequirements } from 'services/rewards';

export const generateDescription = (
  requirements: IRewardRequirements<unknown>
) =>
  requirements.strictRequirements?.title ||
  requirements.notStrictRequirements?.title ||
  'Coming soon...';
